import React from 'react'
import ReactDOM from 'react-dom'
import { injectGlobal } from 'styled-components'
import styledNormalize from 'styled-normalize'
import { Provider as RebassProvider } from 'rebass'

import App from './components/App'

import theme from './constants/theme'

// noinspection CssUnknownTarget
injectGlobal`
  @import url('https://fonts.googleapis.com/css?family=Open+Sans:300,400,500');
  
  ${styledNormalize}
  
  *, *:before, *:after {
    box-sizing: border-box;
    font-family: 'Open Sans', sans-serif;
  }
  
  html, 
  body,
  #root,
  .auta {
    height: 100%;
  }
`

ReactDOM.render(
  <RebassProvider theme={theme}>
    <App />
  </RebassProvider>, document.getElementById('root')
)


// WEBPACK FOOTER //
// ./src/index.js